export default "__VITE_ASSET__5566b9c6__"